import { axiosInstance } from "lib/axios";
import { searchAPI } from "services/apis.service";
import { searchEngineCounts } from "config";

const createAcademiaAdapter = ({ searchContext, params }) => {
  const {
    currentSearchTerm,
    currentSubCategory,
  } = searchContext;

  const pageSize = searchEngineCounts["Academia"];
  const enabled = Boolean(currentSearchTerm && currentSubCategory);
  const dependencies = [
    currentSearchTerm,
    currentSubCategory,
  ];

  const fetchPage = async (cursor) => {
    if (!enabled) return { items: [], nextCursor: cursor, hasMore: false };

    const { data } = await axiosInstance.post(
      searchAPI.academiaSearch,
      {
        query: currentSearchTerm,
        offset: String(cursor),
        academiaId: Number(currentSubCategory),
        limit: String(pageSize),
      }
    );

    const items = data?.data?.results || [];
    const total = data?.data?.totalEstimatedMatches || 0;
    const nextCursor = cursor + pageSize;
    const hasMore = nextCursor < total;

    return { items, nextCursor, hasMore };
  };

  return {
    idKey: "url",
    initialCursor: 0,
    fetchPage,
    dependencies,
    enabled,
    isPageMode: false,
  };
};

export default createAcademiaAdapter;

